import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceAdminService {

  constructor() {
  }
  isEnabled = (companyDomain: string) => environment.selfService && environment.selfService.enabled && new RegExp(environment.selfService.matcher, 'gi').test(companyDomain);
  redirectUrl = environment.selfService.url;
  getJumpUrl = (accessToken: string, refreshToken: string) => `${this.redirectUrl}#access_token=${accessToken}&refresh_token=${refreshToken}`;
}
